import { createApp } from 'vue';
import http from './plugins/http';
import SubscribeApp from '../components/checkout/SubscribeApp.vue';

const el = document.getElementById('vSubscribe');

if( el ) {

    const {
        subscriptionId,
        subscriptionSlug,
        tier,
        isAuth,
        price,
        userEmail,
        userName
    } = el.dataset;

    createApp( SubscribeApp, {
        subscriptionId   : Number( subscriptionId ),
        subscriptionSlug : String( subscriptionSlug || '' ),
        tier             : String( tier || '' ),
        price            : Number( price ),
        isAuth           : isAuth === '1',
        userEmail        : userEmail || '',
        userName         : userName  || '',
    }).use(http).mount(el);
}